import { app } from '../../../../app';

app.service('SmsUsageReportModal', modal);

/** @ngInject */
function modal($state, $uibModal) {

    return ({periodFilter, startDate, endDate}) => {

        return $uibModal.open({
            component: 'smsUsageReport',
            resolve: {usageReport}
        }).result;

        /** @ngInject */
        function usageReport(SmsServices) {
            const companyId = $state.params.companyId;
            return SmsServices.smsUsageReport(companyId, periodFilter, startDate, endDate);
        }
    };
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/sms-usage-report/sms-usage-report.modal.js